<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p>I would like to thank the following people who made meaningful contribution to the writing of my book. If it were not for them, this book would have remained a draft forever.</p><br/>
<p style="text-indent: 0em;">Dr Charlie Rampfumedzi for being a fellow brother in Christ and mentor and for your contribution to the book by providing valuable inputs and insights regarding the theological editing of the book. Thank you for your unwavering commitment to the supremacy of Jesus Christ and the authority of Scripture. I learnt a lot every time I read your comments on the manuscript of this book regarding theological correctness.</p><br/>
<p style="text-indent: 0em;">Indeed, God uses means to accomplish His purposes. My special thanks goes to Dr John Street and the faculty of biblical counselling at The Master’s University in California, USA, for allowing God to use you to entrust the gospel to the next generation of ministers of God’s Word and biblical counsellors, of which, by the grace of God, I am one of them. I went to the university to study Master of Arts in Biblical Counselling, but God, who works in mysterious ways, gave me the understanding of expository preaching over and above the biblical counselling I needed to study. And as you taught us, one cannot be a biblical counsellor without being an expositor of God’s Word. Thank you for giving me the gift of the Bible that resulted in the writing of this book to help others receive the same blessing I’ve received from you—which is reading and understanding all the genres of the Bible with simplicity, clarity and boldness.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?d3dd7caa